import React from 'react';
import { Globe } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from './ui/tooltip';
import { getCountryName } from '../data/countries';

const CountryFlag = ({ country, province, size = 'default', className = '' }) => {
  const countryCode = country?.toUpperCase();
  const countryName = getCountryName(countryCode) || country;
  
  // Size configurations
  const sizes = {
    small: { img: 'h-4', globe: 'h-4 w-4', minWidth: '16px' },
    default: { img: 'h-5', globe: 'h-5 w-5', minWidth: '20px' },
    large: { img: 'h-6', globe: 'h-6 w-6', minWidth: '24px' }
  };
  const sizeConfig = sizes[size] || sizes.default;
  
  // Determine what to display and tooltip text
  let displayElement;
  let tooltipText;
  
  // Handle UK -> GB conversion for flag CDN
  const flagCode = countryCode === 'UK' ? 'gb' : countryCode?.toLowerCase();
  
  if (countryCode && countryCode.length === 2 && countryCode !== 'OTHER') {
    // Show country flag using flagcdn.com PNG flags
    displayElement = (
      <img 
        src={`https://flagcdn.com/w40/${flagCode}.png`}
        srcSet={`https://flagcdn.com/w80/${flagCode}.png 2x`}
        alt={`${countryName} flag`}
        className={`${sizeConfig.img} w-auto rounded-sm shadow-sm`}
        style={{ minWidth: sizeConfig.minWidth }}
        onError={(e) => {
          // Fallback to globe if flag fails to load
          e.target.style.display = 'none';
          e.target.nextSibling.style.display = 'block';
        }}
      />
    );
    tooltipText = province ? `${province}, ${countryName}` : countryName;
  } else if (province) {
    // No country but has province - show globe with province info
    displayElement = (
      <Globe className={`${sizeConfig.globe} text-slate-400`} />
    );
    tooltipText = province;
  } else {
    // No location info - show globe
    displayElement = (
      <Globe className={`${sizeConfig.globe} text-slate-400`} />
    );
    tooltipText = 'Location not set';
  }

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <div 
            className={`flex items-center justify-center cursor-default ${className}`}
            data-testid="country-flag"
          >
            {displayElement}
            {/* Hidden globe fallback */}
            <Globe className={`${sizeConfig.globe} text-slate-400 hidden`} />
          </div>
        </TooltipTrigger>
        <TooltipContent side="bottom" className="text-xs">
          <p>{tooltipText}</p>
          <p className="text-slate-400 mt-0.5">Results tailored to your region</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
};

export default CountryFlag;
